import {Rating} from '../starRating/rating';
import {Form} from './form';

class FormWithRating extends Form
{
    initListeners() {
        this.initRatingField();
        super.initListeners();
    }

    initRatingField() {
        this.rating = new Rating(this.container.querySelector('[data-field="rating"]'));
    }

    get data() {
        let data = super.data;
        data.rating = this.rating.value();

        return data;
    }
}

export {FormWithRating};
